import setupHandlersForConsentLink from './setupHandlersForConsentLink';
import maybeOpenPrivacyManagerModal from './maybeOpenPrivacyManagerModal';
import isBot from './isBot';
import isMobileApp from './isMobileApp';
import saveCookie from './saveCookie';
import getConsentState from './getConsentState';
import waitForTCData from './waitForTCData';
import {
  EVENT_LABEL,
  logConsentBannerLoaded,
  logConsentGranted,
  logConsentDenied,
  logSourcepointLibError,
  CHOICE_TYPE,
  PURPOSE_CONSENT,
  VENDOR_CONSENT,
} from './analytics';
import { CONSENT_ACTION, CONSENT_LAYER, CONSENT_METRIC, sendConsentMetric } from './consentMetrics';
import { currentLayer, markSettingsPageOpen } from './consentLayer';
import { w } from './global';

const loadSourcepoint = !(isBot() || isMobileApp());

const { LAYER_ONE, LAYER_TWO, SCOPE_ALL, SCOPE_PARTIAL } = EVENT_LABEL;

const pushConsentChangeToDataLayer = () => {
  w.ecGa('pushToDataLayer', { event: 'setConsent' });
};

w._sp_lib = Object.assign(w._sp_lib || {}, {
  getConsentState,
  waitForTCData,
});
w._sp_queue = [];
w._sp_ = {
  config: {
    accountId: w._sp_ss_config.accountId,
    baseEndpoint: w._sp_ss_config.baseEndpoint,
    propertyHref: encodeURI(w.location.href),
    gdpr: {
      groupPmId: w._sp_ss_config.privacyManagerModalId,
    },
    // if true sourcepoint autoload is disabled
    isSPA: !loadSourcepoint,
    events: {
      onConsentReady: () => {
        void saveCookie();
      },
      onMessageReady: function () {
        const layer = currentLayer();
        logConsentBannerLoaded([layer === CONSENT_LAYER.TWO ? LAYER_TWO : LAYER_ONE]);
        sendConsentMetric(CONSENT_METRIC.MESSAGE_SHOWN, { layer });
      },
      onMessageChoiceSelect: function (messageType, choiceId, choiceTypeId) {
        if (choiceTypeId === CHOICE_TYPE.ACCEPT_ALL) {
          //  2. amount of users who chose “accept all” on the 1st layer
          logConsentGranted([LAYER_ONE, SCOPE_ALL]);
          sendConsentMetric(CONSENT_METRIC.CHOICE, { layer: CONSENT_LAYER.ONE, action: CONSENT_ACTION.ACCEPT_ALL });
          pushConsentChangeToDataLayer();
        } else if (choiceTypeId === CHOICE_TYPE.REJECT_ALL) {
          logConsentDenied([LAYER_TWO]);
          sendConsentMetric(CONSENT_METRIC.CHOICE, { layer: CONSENT_LAYER.ONE, action: CONSENT_ACTION.REJECT_ALL });
          pushConsentChangeToDataLayer();
        } else if (choiceTypeId === CHOICE_TYPE.SETTINGS) {
          sendConsentMetric(CONSENT_METRIC.CHOICE, { layer: CONSENT_LAYER.ONE, action: CONSENT_ACTION.SETTINGS });
          markSettingsPageOpen();
        }
      },
      onPrivacyManagerAction: function (messageType, { vendorConsent, purposeConsent }) {
        pushConsentChangeToDataLayer();

        const allAccepted = purposeConsent === PURPOSE_CONSENT.ALL && vendorConsent === VENDOR_CONSENT.ALL;
        const noneAccepted = purposeConsent === PURPOSE_CONSENT.NONE && vendorConsent === VENDOR_CONSENT.NONE;
        sendConsentMetric(CONSENT_METRIC.CHOICE, {
          layer: CONSENT_LAYER.TWO,
          action: allAccepted
            ? CONSENT_ACTION.ACCEPT_ALL
            : noneAccepted
              ? CONSENT_ACTION.REJECT_ALL
              : CONSENT_ACTION.PARTIAL,
        });

        if (purposeConsent === PURPOSE_CONSENT.ALL && vendorConsent === VENDOR_CONSENT.ALL) {
          // 6. amount of users who chose the “save and continue” option on the 2nd layer, while they accepted all the 10 purposes and all the vendors by enabling all the toggles.
          // 7. amount of users who chose “accept all” on the 2st layer
          logConsentGranted([LAYER_TWO, SCOPE_ALL]);
        } else if (purposeConsent === PURPOSE_CONSENT.NONE && vendorConsent === VENDOR_CONSENT.NONE) {
          // 4. amount of users who chose the “save and continue” option on the 2nd layer, while they didn’t provide any consent. That means they either provided only legitimate interest (they didn’t change the settings) or rejected everything including legitimate interest (by disabling all the toggles).
          logConsentDenied([LAYER_TWO]);
        } else if (purposeConsent === PURPOSE_CONSENT.SOME && vendorConsent === VENDOR_CONSENT.SOME) {
          // 5. amount of users who chose the “save and continue” option on the 2nd layer , while they provided partial consent. This means that they consented to some of the purposes or vendors, but not to all of them.
          logConsentGranted([LAYER_TWO, SCOPE_PARTIAL]);
        }
      },
      onError: function (messageType, errorCode, errorObject) {
        logSourcepointLibError([JSON.stringify(errorObject)]);
      },
    },
  },
};

if (loadSourcepoint) {
  w.addEventListener('DOMContentLoaded', () => {
    setupHandlersForConsentLink();
  });
  w._sp_queue.push(() => {
    maybeOpenPrivacyManagerModal();
  });
}
